import { render, staticRenderFns } from "./LeadsSeo.vue?vue&type=template&id=12f46200&scoped=true"
import script from "./LeadsSeo.vue?vue&type=script&lang=js"
export * from "./LeadsSeo.vue?vue&type=script&lang=js"
import style0 from "./LeadsSeo.vue?vue&type=style&index=0&id=12f46200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f46200",
  null
  
)

export default component.exports